
<div class="row" *ngIf ="!addPayment">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header" >

        <div class="filter-wrapper field_space" *ngIf = "form">
          <form   [formGroup]="form" novalidate (ngSubmit)="saveData()">

                <div class="form-group col-4-div" >
                    <label>Donation Date*</label>
                    <input class="form-control border-primary" (ngModelChange) = "onDateChange()" [owlDateTime]="dt2"   placeholder="Date" name="donation_date" formControlName="donation_date"
                        readonly>
                    <span [owlDateTimeTrigger]="dt2" class="date-ico"><i class="fa fa-calendar"></i></span>
                    <owl-date-time #dt2 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    <div class=""  *ngIf="dateErrorMsg">
                    <div  class="inaild_no">{{dateErrorMsg}}</div>
                    </div>
                    <!-- <span *ngIf="dateErrorMsg"  style="color: red; font-size: 12px">{{dateErrorMsg}}</span> -->
                    <div class="" *ngIf="form.controls.donation_date.touched && !form.controls.donation_date.valid">
                    <div  class="inaild_no" *ngIf=" form.controls.donation_date.errors.required">Donation Date is required!</div>
                    </div>

                </div>

                <div class="form-group col-4-div">
                <label>Bhojan Prasad *</label>

                <select
                    class="form-control border-primary"
                    formControlName="annakshetra_meal_type_id">

                    <option value="">Select</option>

                    <option
                    *ngFor="let item of mealTypes"
                    [value]="item.id">

                    {{item.title}} - {{item.amount}}
                    </option>

                </select>
                </div>

                <div class="form-group col-4-div">
                <label>Mobile Number *</label>

                <input
                    class="form-control border-primary"
                    formControlName="mobile_no">
                </div>

                <div class="form-group col-4-div">
                <label>Address</label>

                <textarea
                    class="form-control border-primary"
                    formControlName="address"
                    rows="2"
                    placeholder="Enter address (optional)">
                </textarea>
                </div>

                <!-- <div class="form-group col-4-div">

                </div> -->

                <div class="form-group col-4-div">
                <label>Full Name (English) *</label>

                <input
                    class="form-control border-primary"
                    formControlName="full_name">
                </div>

                <div class="form-group col-4-div">
                <label>Full Name (Hindi) </label>

                <input
                    class="form-control border-primary"
                    formControlName="hindi_name">
                </div>

                <div class="form-group col-4-div">
                <label>Occasion (English) </label>

                <input
                    class="form-control border-primary"
                    formControlName="occasion">
                </div>

                <div class="form-group col-4-div">
                <label>Occasion (Hindi) </label>

                <input
                    class="form-control border-primary"
                    formControlName="hindi_occasion">
                </div>

                <div
                    class="button-wrap"
                    *ngIf="form.value.full_name || form.value.hindi_name">

                    <button
                        type="button"
                        class="btn btn-info"
                        (click)="openPreview()">
                        Preview Certificate
                    </button>
                </div>

                <div class="form-group col-12-div" style="min-height: 40px;">
                <input
                    type="checkbox"
                    formControlName="require_80g_certificate"
                    (change)="on80GChange()">

                I require 80G certificate for tax benefits
                </div>

                <div
                class="form-group col-6-div"
                *ngIf="form.value.require_80g_certificate">

                <label>PAN Card Number *</label>

                <input
                    class="form-control"
                    formControlName="pan_card_no">
                </div>

                <div class="button-wrap">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="saveData()">

                    Proceed To Donate
                </button>
                </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="display: inline-block;width: 100%;height: auto;" *ngIf ="addPayment">
  <div style="width: 100%; float: left; padding-left: 20px;box-sizing: border-box;">
    <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
      
      <li class="wrapper_label">
        <label>Full Name</label>
        <small>{{donationData?.full_name}}</small>
      </li>
      <!-- <li class="wrapper_label" *ngIf="donationData?.occasion">
        <label>occasion</label>
        <small>{{donationData?.occasion}}</small>
      </li> -->
      <!-- <li class="wrapper_label">
        <label>Mobile Number</label>
        <small>{{donationData?.mobile_no}}</small>
      </li> -->
      <li class="wrapper_label">
        <label>Donation Date</label>
        <small>{{donationData?.donation_date}}</small>
      </li>
      <li class="wrapper_label">
        <label>Bhojan Prasad</label>
        <small>{{donationData?.meal_type}}</small>
      </li>
      <li class="wrapper_label">
        <label>Amount</label>
        <small>{{donationData?.amount}}</small>
      </li>
      <li class="wrapper_label" *ngIf = "donationData?.payment_process_completed == true">
        <label>Payment Status</label>
        <small>{{donationData.payment_process_completed == true ? 'Completed' : 'Pending'}}</small>
      </li>
      <li class="wrapper_label">
        <button  *ngIf = "donationData?.payment_process_completed == true" style="margin-top: 50px;"
        class="btn btn-primary btn-fw" (click)="viewPass()">VIEW ENTRY PASS</button>
      </li>
    </ul>
    <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;" *ngIf = "donationData?.payment_process_completed == false">
      <div class="form-group col-4-div wrapper_label" style="padding-right: 10px;box-sizing: border-box;width: 30%;">
        <label >Payment Mode*</label>
        <select class="form-control border-primary"  name="payment_type_id" [(ngModel)]="payment_type_id" required>
          <option [value]="''">select</option>
          <!-- <option *ngFor="let data of allPaymentTypes" [value]="data.id">{{data.type}}</option> -->
          <ng-container *ngFor="let data of allPaymentTypes">
                    <option [value]="data.id">{{data.type}}
                    </option>
                  </ng-container>
        </select>
      </div>

      <div *ngIf = "payment_type_id != 2 && payment_type_id != 3" class="form-group col-6-div wrapper_label" style="padding-right: 10px;box-sizing: border-box;width: 30%;">
        <label >Transaction No. / Receipt No.*</label>
        <input class="form-control border-primary" type="text" (ngModelChange)= "removeSpaces()"  [(ngModel)]="transaction_no" name="transaction_no" required>
        <div  class="inaild_no" *ngIf="transaction_validation_msg">{{transaction_validation_msg}}</div>
      </div>

      <div class="button-wrap">
        <button  type="submit" (click) = "savePayData()" *ngIf = "payment_type_id != 2 && payment_type_id != 3"  [disabled]="payment_type_id == '' || transaction_no == '' || transaction_validation_msg" class="btn btn-primary btn-fw" style="margin-right: 10px;">Print</button>
        <button  type="submit" (click) = "addPaymentDetail()" *ngIf = "payment_type_id == 2 || payment_type_id == 3"  [disabled]="payment_type_id == ''" class="btn btn-primary btn-fw" style="margin-right: 10px;">Next</button>
        <button  type="button" class="btn btn-secondary btn-fw" (click)="closePay()">Close</button>
      </div>
    </ul>
  </div>
</div>

<!-- Certificate Preview Modal -->
<div
  class="modal fade show"
  *ngIf="showPreviewModal"
  style="display:block;background:rgba(0,0,0,.5)">

  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h5>Certificate Preview</h5>

        <button
          type="button"
          class="btn"
          (click)="closePreview()" style="padding: 5px; font-size: 13px;font-weight: 500;border: 2px solid #333;">
          X
        </button>
      </div>

      <div class="modal-body">

        <div class="certificate-wrapper">

          <img
            class="certificate-bg"
            src="assets/images/backgroud_bg.png"
            alt="Certificate Background">

          <div class="certificate-content">

            <!-- Hindi -->

            <div class="hindi-section">

              <h2 class="devotee-name">
                प्रिय {{ form.value.hindi_name || form.value.full_name }}
              </h2>

              <p class="certificate-text">

                <span *ngIf="form.value.hindi_occasion || form.value.occasion">

                  {{ form.value.hindi_occasion || form.value.occasion }}

                  के अवसर पर

                </span>

                श्री महाकालेश्वर ज्योतिर्लिंग, उज्जैन के अन्नक्षेत्र में
                आपके द्वारा किए गए अन्नदान के इस पुण्य कार्य की हम
                हृदय से सराहना करते हैं।

              </p>

            </div>

            <!-- English -->

            <div class="english-section">

              <h2 class="devotee-name english-name">
                Dear {{ form.value.full_name || form.value.hindi_name }}
              </h2>

              <p class="certificate-text english-text">

                <span *ngIf="form.value.occasion || form.value.hindi_occasion">

                  On the occasion of

                  {{ form.value.occasion || form.value.hindi_occasion }},

                </span>

                your noble act of Annadaan at the Annakshetra of
                Shri Mahakaleshwar Jyotirlinga, Ujjain is sincerely appreciated.

              </p>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>